import { Component, Input, OnInit } from '@angular/core';
import { AgreementService } from '../services/agreement.service';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';

@Component({
  selector: 'app-agreement-section',
  templateUrl: './agreement-section.component.html',
  styleUrls: ['./agreement-section.component.css']
})
export class AgreementSectionComponent implements OnInit {

  @Input() sectionTitle: string = 'Associated Agreements';
  @Input() venue_id: number | null = null;
  @Input() client_id: number | null = null;
  @Input() client_name: string = null;
  @Input() venue_name: string = null;
  @Input() displayClientName: boolean = false;
  @Input() displayVenueName: boolean = false;

  loadingAgreements: boolean = false;
  isSavingModal: boolean = false;
  addNewAgreementIsActive: boolean = false;
  modalErrorMessage: string = '';
  showInactiveAgreements: boolean = false;
  showLastEventDate: boolean = false;

  clientTypeaheadOption: TypeaheadOption = null;
  venueTypeaheadOption: TypeaheadOption = null;

  createNewClient: boolean = false;
  newClientName: string = '';
  newClientCompanyName: string = '';
  newClientBillingFrequency: string = 'weekly';
  createNewVenue: boolean = false;
  newVenueName: string = '';
  newVenueAddress: string = '';
  newVenueCity: string = '';
  newVenueState: string = '';
  newVenueZip: string = '';
  newVenueIsPrivate: boolean = false;
  newVenueIsTest: boolean = false;

  agreements: Agreement[] = [];

  // agreement form data
  minFirstEventDate: string = '';
  minLastEventDate: string = '';
  newAgreementData: Partial<Agreement> = {
    first_event: '',
    last_event: '',
    contract_date: '',
    is_private: false,
    active: true,
    client_id: this.client_id || null
  };
  newAgreementDetails: Partial<AgreementChange> = {
    game_type: 'trivia',
    is_online: false,
    is_ihh: false,
    day_of_week: 1,
    event_time: '19:00',
    event_interval: 'weekly',
    kt_venue_id: this.venue_id || null
  };

  constructor(private agreementService: AgreementService) { }

  ngOnInit(): void {
    this.loadAgreements();
    if(this.client_id){
      this.clientTypeaheadOption = {
        sid: this.client_id,
        name: this.client_name
      };
    }
    if(this.venue_id){
      this.venueTypeaheadOption = {
        sid: this.venue_id,
        name: this.venue_name
      };
    }
  }

  loadAgreements(){
    if(this.venue_id){
      this.getVenueAgreements();
      return;
    }
    if(this.client_id){
      this.getClientAgreements();
      return;
    }
  }

  toggleCreateNewClient() {
    if(this.createNewClient){
      this.createNewClient = false;
      this.newClientName = '';
      this.newClientCompanyName = '';
      this.newClientBillingFrequency = 'weekly';
    }
    else {
      this.createNewClient = true;
      this.newAgreementData.client_id = null;
    }
  }

  toggleCreateNewVenue() {
    if(this.createNewVenue){
      this.createNewVenue = false;
      this.newVenueName = '';
      this.newVenueAddress = '';
      this.newVenueCity = '';
    }
    else {
      this.createNewVenue = true;
      this.newAgreementDetails.kt_venue_id = null;
    }
  }
  getVenueAgreements() {
    if (!this.venue_id) return;
    this.loadingAgreements = true;
    this.agreementService.getVenueAgreements(this.venue_id).subscribe({
      next: (res: MultipleAgreementResponse) => {
        this.agreements = res.data;
        this.loadingAgreements = false;
      },
      error: (err) => {
        this.loadingAgreements = false;
        console.error("Error fetching agreements:", err);
      }
    });
  }

  getClientAgreements() {
    if (!this.client_id) return;
    this.loadingAgreements = true;
    this.agreementService.getClientAgreements(this.client_id).subscribe({
      next: (res: MultipleAgreementResponse) => {
        this.agreements = res.data;
        this.loadingAgreements = false;
      },
      error: (err) => {
        this.loadingAgreements = false;
        console.error("Error fetching client agreements:", err);
      }
    });
  }

  handleClientOrVenueSelect(selectedItem: any, itemType: string) {;
    if( itemType === 'client' ){
      this.newAgreementData.client_id = selectedItem.sid;
      return;
    }
    if( itemType === 'venue' ){
      this.newAgreementDetails.kt_venue_id = selectedItem.sid;
      return;
    }
  }

  // Agreement Management
  showAddNewAgreement(): void {
    this.resetAgreementForm();
    this.addNewAgreementIsActive = true;
  }

  resetAgreementForm(): void {
    this.createNewClient = false;
    this.createNewVenue = false;
    this.newClientName = '';
    this.newClientCompanyName = '';
    this.newClientBillingFrequency = 'weekly';
    this.newVenueName = '';
    this.newVenueAddress = '';
    this.newVenueCity = '';
    this.newVenueState = '';
    this.newVenueZip = '';
    this.newAgreementData = {
      first_event: '',
      last_event: '',
      contract_date: '',
      is_private: false,
      active: true,
      client_id: this.client_id || null
    };
    this.newAgreementDetails = {
      game_type: 'trivia',
      is_online: false,
      is_ihh: false,
      day_of_week: 1,
      event_time: '19:00',
      event_interval: 'weekly',
      kt_venue_id: this.venue_id || null
    };
    this.modalErrorMessage = '';
  }

  translateGameType(gametype: string): string {
    switch (gametype) {
      case 'trivia':
        return 'Pub Quiz';
      case 'bingo':
        return 'Music Bingo';
      case 'slam':
        return 'Survey Slam';
      default:
        return "Special Event";
    }
  }

  createNewAgreement() {
    if (!this.newAgreementDetails.kt_venue_id) {
      if (!this.createNewVenue) {
        this.modalErrorMessage = 'Please select a venue.';
        return;
      }
      else if (!this.newVenueName || !this.newVenueCity || !this.newVenueState) {
        this.modalErrorMessage = 'Please fill in the new venue details: name, city, and state are required.';
        return;
      }
    } 
    
    if (!this.newAgreementData.client_id && !this.createNewClient) {
      this.modalErrorMessage = 'Please select a client.';
      return;
    }

    if (!this.newAgreementDetails.game_type) {
      this.modalErrorMessage = 'Please select a game type.';
      return;
    }

    if (!this.newAgreementData.contract_date) {
      this.modalErrorMessage = 'Please fill in contract date.';
      return;
    }

    if (!this.newAgreementDetails.event_time) {
      this.modalErrorMessage = 'Please fill in event time.';
      return;
    }

    if (this.newAgreementDetails.event_interval !== 'one-time') {
      if (!this.newAgreementData.first_event || !this.newAgreementDetails.day_of_week) {
        this.modalErrorMessage = 'Recurring events require a first event date and day of week.';
        return;
      }
    }

    if (this.newAgreementDetails.event_interval === 'one-time') {
      if (!this.newAgreementDetails.event_date || !this.newAgreementDetails.event_name) {
        this.modalErrorMessage = 'One time events require an event date and name.';
        return;
      }
    }

    this.isSavingModal = true;
    this.modalErrorMessage = '';

    const payload: any = {
      rate: this.newAgreementDetails.rate || 0,
      client_id: this.newAgreementData.client_id || 0,
      kt_venue_id: this.newAgreementDetails.kt_venue_id || 0,
      game_type: this.newAgreementDetails.game_type,
      day_of_week: this.newAgreementDetails.day_of_week || 0,
      event_name: this.newAgreementDetails.event_interval === 'one-time' 
        ? this.newAgreementDetails.event_name 
        : this.translateGameType(this.newAgreementDetails.game_type),
      is_online: this.newAgreementDetails.is_online || false,
      is_ihh: this.newAgreementDetails.is_ihh || false,
      active: this.newAgreementData.active || true,
      is_private: this.newAgreementData.is_private || false,
      event_time: this.newAgreementDetails.event_time,
      event_interval: this.newAgreementDetails.event_interval,
      contract_date: this.newAgreementData.contract_date,
      event_date: this.newAgreementDetails.event_interval === 'one-time' 
        ? this.newAgreementDetails.event_date : null,
      first_event: this.newAgreementDetails.event_interval !== 'one-time' 
        ? this.newAgreementData.first_event : this.newAgreementDetails.event_date || null,
      last_event: this.newAgreementData.last_event
        ? this.newAgreementData.last_event : null
    };

    if (this.createNewClient) {
      payload.create_new_client = true;
      payload.client_name = this.newClientName;
      payload.company_name = this.newClientCompanyName;
      payload.billing_frequency = this.newClientBillingFrequency;
    }
    if (this.createNewVenue) {
      payload.create_new_venue = true;
      payload.name = this.newVenueName;
      payload.address = this.newVenueAddress;
      payload.city = this.newVenueCity;
      payload.state = this.newVenueState;
      payload.zip_code = this.newVenueZip;
      payload.is_private = this.newVenueIsPrivate;
      payload.is_test = this.newVenueIsTest;
    }

    this.agreementService.newAgreement(payload).subscribe({
      next: (response: { data: Agreement }) => {
        console.log('Agreement created successfully:', response);
        this.isSavingModal = false;
        this.addNewAgreementIsActive = false;
        this.agreements.push(response.data);
      },
      error: (error) => {
        console.error('Error creating agreement:', error);
        this.isSavingModal = false;
        this.modalErrorMessage = 'Failed to create agreement. Please try again.';
      }
    });

  }

  removeAgreement(agreement_id: number) {
    this.agreements = this.agreements.filter(ag => ag.agreement_id !== agreement_id);
  }

  onContractDateChange() {
    // set min first event date based on contract date
    if (this.newAgreementData.contract_date) {
      const contractDate = new Date(this.newAgreementData.contract_date);
      this.minFirstEventDate = new Date(contractDate).toISOString().split('T')[0];
    }
  }

  onFirstEventDateChange() {
    if (this.newAgreementData.first_event) {
      const firstEventDate = new Date(this.newAgreementData.first_event);
      this.minLastEventDate = new Date(firstEventDate).toISOString().split('T')[0];
    }
  }

  onEventIntervalChange() {
    if (this.newAgreementDetails.event_interval === 'one-time') {
      this.newAgreementDetails.day_of_week = 0;
      this.newAgreementDetails.event_name = "";
    }
    else {
      this.newAgreementDetails.day_of_week = 1;
      this.newAgreementDetails.event_name = this.translateGameType(this.newAgreementDetails.game_type);
      this.newAgreementDetails.event_date = null;
    }
  }


  // end
}
